/**
 * 表格列排序 / 字段设置相关的展示文案常量
 * 统一管理，避免在各处硬编码中文 / 英文字符串
 */
export const COLUMN_DISPLAY_TEXT = {
  COMPARE_TIME: {
    CN: '对比时间',
    EN: 'Compare Time',
  },
  COMPARISON_GROUP: {
    CN: '对照组',
    EN: 'Comparison',
  },
} as const;


